module.exports = __webpack_public_path__ + "img/V76.61dfbd9b.jpg";